import * as moment from "moment";
import React, { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  RSelect,
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { GET } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { PROCESSING_INVENTORY_INGREDIENT_ID } from "../../utils/Utils";

const renderWeight = (value) => (
  <div className="text-right">
    <NumericFormat displayType="text" value={value || 0} thousandSeparator="," decimalScale={2} suffix=" kg" />
  </div>
);

// Kho gia công: tồn hàng của KH có tick "nhận gia công", theo KH + nguyên liệu
const ProcessingInventory = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerId, setCustomerId] = useState();
  const [ingredientOptions, setIngredientOptions] = useState([]);
  const [ingredientId, setIngredientId] = useState();
  const [rangeDate, setRangeDate] = useState({
    startDate: moment().startOf("months").toDate(),
    endDate: moment().endOf("days").toDate(),
  });

  useEffect(() => {
    GET("customer", { isProcessingCustomer: true }, true).then(({ data: res }) => {
      setCustomerOptions((res || []).map((c) => ({ label: c.name, value: c.id })));
    });
    GET("ingredient", {}, true).then(({ data: res }) => {
      setIngredientOptions(
        (res?.rows || [])
          // Kho gia công hiện chỉ theo dõi dầu tinh (DTP)
          .filter((c) => c.id === PROCESSING_INVENTORY_INGREDIENT_ID)
          .map((c) => ({ label: c.name, value: c.id }))
      );
    });
  }, []);

  useEffect(() => {
    if (!rangeDate.startDate || !rangeDate.endDate) {
      return;
    }
    setLoading(true);
    GET("processing/inventory", {
      fromDate: moment(rangeDate.startDate).format("YYYY-MM-DD"),
      toDate: moment(rangeDate.endDate).format("YYYY-MM-DD"),
      ...(customerId ? { customerId } : {}),
      ...(ingredientId ? { ingredientId } : {}),
    }, true)
      .then(({ data: res }) => {
        setData(res?.rows || []);
        setSummary(res?.summary || {});
      })
      .finally(() => setLoading(false));
  }, [rangeDate, customerId, ingredientId]);

  const onRangeChange = (dates) => {
    const [startDate, endDate] = dates;
    setRangeDate({
      startDate: startDate ? moment(startDate).startOf("days").toDate() : startDate,
      endDate: endDate ? moment(endDate).endOf("days").toDate() : endDate,
    });
  };

  const columns = [
    {
      Header: "Khách hàng",
      accessor: (item) => item.customerName,
    },
    {
      Header: "Nguyên liệu",
      accessor: (item) => item.ingredientName,
    },
    {
      Header: "Đầu kỳ",
      accessor: (item) => renderWeight(item.firstWeight),
    },
    {
      // = KL dầu thô ép nhận gia công x tỷ lệ nấu từ dầu ép
      Header: "Nhập sản xuất",
      accessor: (item) => renderWeight(item.produceInWeight),
    },
    {
      Header: "Xuất",
      accessor: (item) => renderWeight(item.outWeight),
    },
    {
      Header: "Cuối kỳ",
      accessor: (item) => renderWeight(item.lastWeight),
    },
  ];

  return (
    <React.Fragment>
      <Head title="Kho gia công" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Kho gia công</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                <li>
                  <div className="form-control-wrap" style={{ width: 250 }}>
                    <RSelect
                      isClearable
                      placeholder="Khách hàng"
                      options={customerOptions}
                      value={customerOptions.find((c) => c.value === customerId) || null}
                      onChange={(val) => setCustomerId(val?.value)}
                    />
                  </div>
                </li>
                <li>
                  <div className="form-control-wrap" style={{ width: 250 }}>
                    <RSelect
                      isClearable
                      placeholder="Nguyên liệu"
                      options={ingredientOptions}
                      value={ingredientOptions.find((c) => c.value === ingredientId) || null}
                      onChange={(val) => setIngredientId(val?.value)}
                    />
                  </div>
                </li>
                <li>
                  <div className="form-control-wrap">
                    <DatePicker
                      selected={rangeDate.startDate}
                      startDate={rangeDate.startDate}
                      onChange={onRangeChange}
                      endDate={rangeDate.endDate}
                      maxDate={new Date()}
                      selectsRange
                      className="form-control date-picker"
                    />
                  </div>
                </li>
              </ul>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div className="table-full-width">
                <Table
                  loading={loading}
                  columns={columns}
                  data={data}
                  notShowPagi
                  customRow={() => data.length > 0 ? (
                    <tr className="font-weight-bold">
                      <td colSpan={2}>Tổng cộng</td>
                      <td>{renderWeight(summary.firstWeight)}</td>
                      <td>{renderWeight(summary.produceInWeight)}</td>
                      <td>{renderWeight(summary.outWeight)}</td>
                      <td>{renderWeight(summary.lastWeight)}</td>
                    </tr>
                  ) : <></>}
                />
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default ProcessingInventory;
